import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'

import { Box } from '@mui/material'
import request from 'api'
import { HttpStatusCode } from 'axios'
import { ConsentConstants } from 'pages/constants'
import { getConsentApiCountry } from 'pages/policies/api'
import { Consent } from 'pages/policies/utils'
import Detail from 'pages/policies/views/detail'
import i18n from 'utils/i18n'

export const PrivacyNoticesAndPolicies = (consentInfo: { consentCode: string }) => {
  const { appId } = useParams()
  const countryCode = i18n.countryCode3digit
  const language3DigitCode = i18n.languageCode3digit

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [consent, setConsent] = useState<Consent>()
  const [detail, setDetail] = useState<string>('<div/>')
  const isMounted = useRef<Boolean>(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (isMounted.current === false) {
      getConsent()
    }
  }, [])

  const getDetailApi = async (uri: string) => {
    try {
      const result = await request.get(uri)
      if (result.status !== HttpStatusCode.Ok) {
        throw new Error(ConsentConstants.FAILED_CONSENT_RESPONSE)
      }
      const document = new DOMParser().parseFromString(result.data, 'text/html')
      const body = document.getElementsByTagName('body').item(0)?.innerHTML

      if (body !== undefined) {
        setDetail(body)
      } else {
        setDetail('<div>Failed to load</div>')
      }
    } catch (err) {
      if (isMounted.current) {
        setDetail('<div>Failed to load</div>')
      }
    }
  }

  const getConsent = async () => {
    try {
      const result = await getConsentApiCountry(
        consentInfo.consentCode,
        false,
        countryCode,
        language3DigitCode,
        undefined,
        false,
        appId
      )
      if (result.status !== HttpStatusCode.Ok) {
        throw new Error(ConsentConstants.FAILED_CONSENT_RESPONSE)
      }
      const data = result.data[0] as Consent
      setConsent(data)
      await getDetailApi(data.uri)
      isMounted.current = true
    } catch (err) {
      if (isMounted.current) {
        setConsent(undefined)
      }
    } finally {
      if (isMounted.current) {
        setIsLoading(false)
      }
    }
  }

  return (
    <Box>
      <Detail title={consent?.title || ''} isLoading={isLoading} detail={detail} />
    </Box>
  )
}
